import React from "react";
import { DEFAULT_FREE_TRIAL_LIMIT } from "~/features/billing/constants";
import { UsageLimitModal } from "~/features/billing/UsageLimitModal";

/**
 * QA test page that forces the UsageLimitModal to appear
 * regardless of actual account balance.
 * Route: /billing/test-limit-reached
 */
export const TestLimitReachedPage: React.FC = () => {
  return (
    <UsageLimitModal
      organizationId="test-org"
      freeTrialLimit={DEFAULT_FREE_TRIAL_LIMIT}
    />
  );
};
